<template>
  <div
    class="travelers-details-form w-100 d-flex flex-column justify-content-start"
    role="tablist"
  >
    <b-card
      v-for="(traveler, index) in traveler_details"
      :key="`traveler-details:${traveler.id}:${index}`"
      class="border-top-0 border-left-0 border-right-0 rounded-0 w-100"
      no-body
    >
      <b-card-header
        header-tag="header"
        class="p-0 border-0 rounded-0 bg-transparent"
        role="tab"
      >
        <button
          v-b-toggle="traveler.id"
          class="btn btn-ghost w-100 d-flex justify-content-between py-3 px-3"
          @click="() => toggle_expanded(traveler.id)"
        >
          <traveler-label :traveler_info="traveler" :index="index">
            <template>
              <vb-icon
                name="check_circle"
                :color="
                  has_filled_required_info(traveler.id)
                    ? color_success
                    : '#adb5bd'
                "
                :icon_style="{
                  '--color': has_filled_required_info(traveler.id)
                    ? color_success
                    : '#adb5bd',
                }"
                :size="14"
              ></vb-icon>
            </template>
          </traveler-label>
          <chevron
            icon="chevron-down"
            :size="14"
            :is_open="is_expanded(traveler.id)"
          />
        </button>
      </b-card-header>
      <b-collapse :id="traveler.id" role="tabpanel" visible>
        <b-card-body class="pt-1">
          <b-row v-if="index === 0" class="pb-2">
            <b-col sm="12">
              <div>
                Questo è il viaggiatore
                <span class="semibold"
                  >principale e Beneficiario della prestazione welfare</span
                >.
                <span class="semibold">A questi riferimenti invieremo</span>
                tutte le informazioni sulla prenotazione e sul volo.
              </div>
              <div>
                Inserisci email e numero di cellulare che consulti spesso.
              </div>
            </b-col>
          </b-row>
          <b-row v-if="is_infant(traveler)" class="pb-2">
            <b-col sm="12">
              <div>
                Attenzione! I bambini da 0 a 2 anni viaggiano in braccio a un
                adulto e non hanno un posto a sedere.
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <div class="form-group">
                <label>Titolo</label>
                <vb-select
                  v-model="traveler_details[index].gender"
                  :vb_options="{
                    id: build_input_id(traveler, 'gender'),
                    persistent_key: build_input_id(traveler, 'gender'),
                    options: genders,
                    text_field: 'text',
                    value_field: 'value',
                  }"
                ></vb-select>
              </div>
            </b-col>
            <b-col lg="3">
              <validation-provider
                rules="required|alpha_spaces|min:2"
                :vid="'traveler_name_' + index"
                name="Nome"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Nome</label>
                  <vb-input
                    v-model="traveler_details[index].firstname"
                    :vb_options="{
                      id: build_input_id(traveler, 'firstname'),
                      persistent_key: build_input_id(traveler, 'firstname'),
                      autocomplete: 'chrome-off',
                    }"
                    @input="
                      (v) => {
                        if (index === 0) {
                          contact_details.firstname = v;
                        }
                      }
                    "
                  />
                </div>
                <span class="vee--errors">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col lg="4">
              <validation-provider
                rules="required|alpha_spaces|min:2"
                :vid="'traveler_surname_' + index"
                name="Cognome"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Cognome</label>
                  <vb-input
                    v-model="traveler_details[index].lastname"
                    :vb_options="{
                      id: build_input_id(traveler, 'lastname'),
                      persistent_key: build_input_id(traveler, 'lastname'),
                      autocomplete: 'chrome-off',
                    }"
                    @input="
                      (v) => {
                        if (index === 0) {
                          contact_details.lastname = v;
                        }
                      }
                    "
                  />
                </div>
                <span class="vee--errors">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col lg="3">
              <validation-provider
                rules="required"
                :vid="'traveler_birth_' + index"
                name="Data di nascita"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Data di nascita</label>
                  <!-- Desktop: input nativo -->
                  <div v-if="!is_mobile()" class="vb-pax__birth">
                    <vb-input
                      v-model="traveler_details[index].birth"
                      :vb_options="{
                        id: build_input_id(traveler, 'birth'),
                        persistent_key: build_input_id(traveler, 'birth'),
                        autocomplete: 'off',
                        placeholder: 'DD/MM/YYYY',
                        min: get_date_range(traveler.traveler_type).min,
                        max: get_date_range(traveler.traveler_type).max,
                        type: 'date',
                        value: traveler_details[index].birth,
                      }"
                      @update="
                        (e) => {
                          traveler_details[index].birth = e;
                        }
                      "
                    />
                  </div>
                  <!-- Mobile: v-date-picker con toggle -->
                  <div
                    v-else
                    :set="(dates = get_date_range(traveler.traveler_type))"
                  >
                    <div
                      class="vb-pax__birth-trigger cursor-pointer"
                      @click="toggle_datepicker(index)"
                    >
                      <vb-icon :name="'calendar'" :size="20" />
                      <b-form-input
                        :value="traveler_details[index].birth ? moment(traveler_details[index].birth).format('DD/MM/YYYY') : ''"
                        placeholder="DD/MM/YYYY"
                        class="vb-input"
                        readonly
                      />
                    </div>
                    <!-- TODO TAZ-549 https://salabam.atlassian.net/browse/TAZ-549
                         Custom header duplicated in LF (travelers-details-form.vue) and VV (quote.vue).
                         Consider unifying with a shared <vb-date-picker> wrapper in src/components/library/. -->
                    <div v-show="datepicker_open[index]" class="vc-wrapper">
                      <v-date-picker
                        :ref="'datepicker_' + index"
                        v-model="traveler_details[index].birth"
                        :model-config="model_config_datepicker"
                        :minDate="dates.min"
                        :maxDate="dates.max"
                        :initial-page="{ year: moment().year(), month: moment().month() + 1 }"
                        @input="() => { toggle_datepicker(index, false) }"
                      >
                        <template #header="page">
                          <div class="vc-header-custom">
                            <span class="vc-header-custom__month">{{ page.monthLabel }}</span>
                            <span class="vc-header-custom__year">
                              <button type="button" class="vc-header-custom__arrow" :class="{ 'is-disabled': page.year <= parseInt(dates.min) }" :disabled="page.year <= parseInt(dates.min)" @click="move_datepicker(-12, index)">‹</button>
                              <span>{{ page.year }}</span>
                              <button type="button" class="vc-header-custom__arrow" :class="{ 'is-disabled': page.year >= parseInt(dates.max) }" :disabled="page.year >= parseInt(dates.max)" @click="move_datepicker(12, index)">›</button>
                            </span>
                          </div>
                        </template>
                      </v-date-picker>
                    </div>
                  </div>
                </div>
                <span class="vee--errors">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row v-if="index === 0 && is_address_required(traveler.id)">
            <b-col md="6" lg="4">
              <validation-provider
                rules="required|max:35"
                name="Indirizzo"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Indirizzo</label>
                  <vb-input
                    v-model="contact_details.address"
                    :vb_options="{
                      id: build_input_id(traveler, 'address'),
                      persistent_key: build_input_id(traveler, 'address'),
                      autocomplete: 'chrome-off',
                    }"
                  />
                </div>
                <span class="vee--errors">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col md="6" lg="4">
              <validation-provider
                rules="required|alpha_spaces|max:35"
                name="Città"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Città</label>
                  <vb-input
                    v-model="contact_details.city"
                    :vb_options="{
                      id: build_input_id(traveler, 'city'),
                      persistent_key: build_input_id(traveler, 'city'),
                      autocomplete: 'chrome-off',
                    }"
                  />
                </div>
                <span class="vee--errors">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col xs="6" sm="6" md="6" lg="2">
              <validation-provider
                rules="required|min:3|max:6|alpha_num"
                name="CAP"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>CAP</label>
                  <vb-input
                    v-model="contact_details.zipcode"
                    :vb_options="{
                      id: build_input_id(traveler, 'zipcode'),
                      persistent_key: build_input_id(traveler, 'zipcode'),
                    }"
                  />
                </div>
                <span class="vee--errors">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col xs="6" sm="6" md="6" lg="2">
              <div class="form-group">
                <label>Paese</label>
                <vb-select
                  v-model="contact_details.country_code"
                  :vb_options="{
                    id: build_input_id(traveler, 'country_code'),
                    persistent_key: build_input_id(traveler, 'country_code'),
                    options: countries,
                    text_field: 'country_name',
                    value_field: 'country_code',
                  }"
                ></vb-select>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="index === 0">
            <b-col lg="2">
              <div class="form-group">
                <label>Prefisso mobile</label>
                <vb-select
                  v-model="contact_details.country_calling_code"
                  :vb_options="{
                    id: build_input_id(traveler, 'phone_code'),
                    persistent_key: build_input_id(traveler, 'phone_code'),
                    options: countries,
                    text_field: 'phone_display',
                    value_field: 'phone_code',
                  }"
                ></vb-select>
              </div>
            </b-col>
            <b-col lg="3">
              <div class="form-group">
                <validation-provider
                  rules="required|min:6|numeric"
                  name="Numero di telefono"
                  v-slot="{ errors }"
                >
                  <label
                    v-b-popover.hover.top="
                      'Per ricevere importanti comunicazioni sulla tua prenotazione, inserisci un numero di cellulare che potrai consultare facilmente anche in mobilità durante il viaggio.'
                    "
                  >
                    Numero di telefono
                    <vb-icon class="info-icon" name="info" :size="12"></vb-icon>
                  </label>
                  <vb-input
                    v-model="contact_details.phone"
                    :vb_options="{
                      id: build_input_id(traveler, 'phone'),
                      persistent_key: build_input_id(traveler, 'phone'),
                      autocomplete: 'chrome-off',
                    }"
                  />
                  <span class="vee--errors">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </b-col>
            <b-col lg="4">
              <validation-provider
                rules="required|email"
                name="Email"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label
                    v-b-popover.hover.top="
                      'Per ricevere importanti comunicazioni sulla tua prenotazione, inserisci un indirizzo che potrai consultare facilmente anche in mobilità durante il viaggio.'
                    "
                  >
                    Email
                    <vb-icon class="info-icon" name="info" :size="12"></vb-icon>
                  </label>
                  <vb-input
                    v-model="contact_details.email"
                    :vb_options="{
                      id: build_input_id(traveler, 'email'),
                      persistent_key: build_input_id(traveler, 'email'),
                      autocomplete: 'chrome-off',
                    }"
                  />
                  <span class="vee--errors">{{ errors[0] }}</span>
                </div>
              </validation-provider>
            </b-col>
          </b-row>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
/**
 * Vincoli date di nascita (relativi a departure_date):
 *
 * HELD_INFANT / SEATED_INFANT: min = partenza - 2 anni + 1g, max = partenza - 2g
 * CHILD:                       min = partenza - 12 anni - 1g, max = partenza - 1g
 * ADULT:                       min = 1900-01-01,              max = partenza - 12 anni
 */
import moment from "moment";
import TravelerLabel from "@liveflight/components/blocks/traveler/traveler-label.vue";

import { countries, genders } from "@/resources";
import { get_traveler_birth_range_dates } from "@liveflight/utilities/flight-offer";
import { build_store_key } from "@/utilities";
import { is_infant } from "@liveflight/utilities/mixins";
import { is_mobile } from "@/utilities/commons";
import { color_success } from "@liveflight/resources/colors";

const TRAVELER_REQUIRED_FIELDS = ["gender", "firstname", "lastname", "birth"];

const CONTACT_REQUIRED_FIELDS = [
  ...TRAVELER_REQUIRED_FIELDS,
  "country_calling_code",
  "phone",
  "email",
];

const CONTACT_ADDRESS_FIELDS = ["address", "city", "zipcode", "country_code"];

export default {
  name: "travelers-details-form",
  props: {
    contact_details: Object,
    flight_offer: Object,
    traveler_details: Array,
    booking_requirements: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    "traveler-label": TravelerLabel,
  },
  data() {
    return {
      color_success,
      genders,
      countries,
      tabState: "",
      datepicker_open: {},
      model_config_datepicker: {
        type: "string",
        mask: "YYYY-MM-DD", // Uses 'iso' if missing
      },
    };
  },
  computed: {
    openTabs: {
      get() {
        try {
          const parsed = JSON.parse(this.tabState);
          return parsed;
        } catch (e) {
          this.log("openTabs error");
          this.log(e);
          return {};
        }
      },
      set(value) {
        this.tabState = JSON.stringify(value);
      },
    },
    departure_date() {
      const od = this.$store.state.liveflight.origin_destinations[0];
      return od && od.date ? od.date : "";
    },
    grouped_ids() {
      const counters = {};
      const grouped_ids = {};
      for (let index = 0; index < this.traveler_details.length; index += 1) {
        const traveler = this.traveler_details[index];
        counters[traveler.traveler_type] =
          (counters[traveler.traveler_type] || 0) + 1;
        grouped_ids[traveler.id] = counters[traveler.traveler_type];
      }
      return grouped_ids;
    },
  },
  created() {
    if (this.traveler_details.length > 0) {
      const first_traveler_id = String(this.traveler_details[0].id);
      this.tabState = JSON.stringify({
        [first_traveler_id]: true,
      });

      // Ensure first passenger is tied to contact details
      this.traveler_details[0] = {
        ...this.traveler_details[0],
        firstname: this.contact_details.firstname || "",
        lastname: this.contact_details.lastname || "",
      };
    }
  },
  methods: {
    moment,
    is_infant,
    is_mobile,
    get_traveler_birth_range_dates,
    build_store_key,
    move_datepicker(months, index) {
      const ref = this.$refs['datepicker_' + index];
      const picker = Array.isArray(ref) ? ref[0] : ref;
      if (picker) picker.move(months).catch(() => {});
    },
    toggle_datepicker(index, force) {
      const current = !!this.datepicker_open[index];
      this.$set(this.datepicker_open, index, force !== undefined ? force : !current);
    },
    build_input_id(traveler, field) {
      const traveler_id = traveler.id;
      return this.build_store_key(
        this.grouped_ids[traveler_id] || traveler_id,
        traveler.traveler_type,
        field,
      );
    },
    is_expanded(traveler_id) {
      return !!this.openTabs[String(traveler_id)];
    },
    toggle_expanded(traveler_id) {
      const old = this.openTabs[String(traveler_id)];
      this.openTabs = {
        ...this.openTabs,
        [String(traveler_id)]: !old,
      };
    },
    get_date_range(traveler_type) {
      switch (traveler_type) {
        case "HELD_INFANT":
        case "SEATED_INFANT":
          return {
            max: moment(this.departure_date).add(-2, "d").format("YYYY-MM-DD"),
            min: moment(this.departure_date)
              .add(-2, "y")
              .add(1, "d")
              .format("YYYY-MM-DD"),
          };
        case "CHILD":
          return {
            max: moment(this.departure_date).add(-2, "d").format("YYYY-MM-DD"),
            min: moment(this.departure_date)
              .add(-12, "y")
              .add(-1, "d")
              .format("YYYY-MM-DD"),
          };
        default: //'ADULT'
          return {
            max: moment(this.departure_date).add(-12, "y").add(-2, "d").format("YYYY-MM-DD"),
            min: "1900-01-01",
          };
      }
    },
    has_filled_required_info(traveler_id) {
      const index = this.traveler_details.findIndex(
        (traveler) => String(traveler_id) === String(traveler.id),
      );
      if (index < 0) {
        return false;
      }

      const required = [];
      if (index === 0) {
        required.push(...CONTACT_REQUIRED_FIELDS);
        if (this.is_address_required(traveler_id)) {
          required.push(...CONTACT_ADDRESS_FIELDS);
        }
      } else {
        required.push(...TRAVELER_REQUIRED_FIELDS);
      }

      const details =
        index === 0
          ? { ...this.traveler_details[index], ...this.contact_details }
          : this.traveler_details[index];
      const valued = Object.entries(details).filter(
        (entry) =>
          required.includes(entry[0]) &&
          !!entry[1] &&
          String(entry[1]).length > 0,
      );

      return valued.length === required.length;
    },
    is_address_required(traveler_id) {
      const traveler_requirements =
        this.booking_requirements.travelerRequirements || [];

      const index = traveler_requirements.findIndex(
        (requirement) => requirement.id === traveler_id,
      );
      if (index >= 0) {
        const requirements = traveler_requirements[index];
        return (
          requirements.redressRequiredIfAny !== false &&
          requirements.residenceRequired !== false
        );
      }

      // There have been errors even if not specified so default to required,
      // Hide only if explicit in the requirements
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.travelers-details-form {
  .info-icon {
    display: inline-block;
    width: 15px;
    height: 15px;

    @include media-breakpoint-up(sm) {
      width: 13px;
      height: 13px;
    }
  }
}

.vb-pax__birth-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  input {
    pointer-events: none;
    cursor: pointer;
    background: $white;
  }
}

.vc-wrapper {
  margin-top: 1rem;
  width: 100%;
  .vc-container {
    width: 100%;
  }
}
</style>
